import React, { useState } from 'react';
import './Modal.css';

const Modal = ({ show, onClose, title, description, publications, links, images, pdfLinks }) => {
  const [searchQuery, setSearchQuery] = useState('');

  if (!show) return null;

  // Filter publications based on the search query
  const filteredPublications = publications
    ? publications.filter(paper =>
        paper.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <p>{description}</p>

        {/* Display PDF Download Links */}
        {pdfLinks && pdfLinks.length > 0 && (
          <div>
            <h4>Download PDF:</h4>
            <ul>
              {pdfLinks.map((pdf, index) => (
                <li key={index}>
                  <a href={pdf.url} download className="download-link">
                    {pdf.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Display links if they exist */}
        {links && links.length > 0 && (
          <div>
            <h4>Useful Links:</h4>
            <ul>
              {links.map((link, index) => (
                <li key={index}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Display images if they exist */}
        {images && images.length > 0 && (
          <div>
            <h4>Images:</h4>
            <div className="">
              {images.map((image, index) => (
                <img key={index} src={image.src} alt={image.alt} className="" />
              ))}
            </div>
          </div>
        )}

        {/* Display Publications if they exist */}
        {publications ? (
          <div className="publications-container">
            <input
              type="text"
              placeholder="Search publications..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <ul className="publications-list">
              {filteredPublications.length > 0 ? (
                filteredPublications.map((paper, index) => (
                  <li key={index} className="publication-item">
                    <h4 className="publication-title">{paper.title}</h4>
                    <p className="publication-authors"><strong>Authors:</strong> {paper.authors}</p>
                    <p className="publication-date"><strong>Published:</strong> {paper.date}</p>
                    <p className="publication-description">{paper.description}</p>
                    <a href={paper.link} target="_blank" rel="noopener noreferrer" className="read-link">Read Full Paper</a>
                  </li>
                ))
              ) : (
                <p className="no-publications">No publications found.</p>
              )}
            </ul>
          </div>
        ) : null}

        <button onClick={onClose} className="close-button">Close</button>
      </div>
    </div>
  );
};

export default Modal;
